import React, { useState } from "react";
import {
  TextField,
  Typography,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

const TextFieldCustomized = ({
  label,
  placeholder,
  isPassword,
  onChange,
  icon,
  unite,
  onIconClick,
  valeur = null,
  onClearClick,
  disabled = false,
  height = 40,
  labelSize = 15,
  error = null,
  obligatoire = false,
  bigField,
  sx, 
  ...restProps
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const borderStyles = {
    borderColor: error ? "red" : "gray",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
      "&:hover fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
      "&.Mui-focused fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: error ? "red" : "gray",
      },
    },
  };

  return (
    <Box sx={{...sx }}> 
      <div style={{ position: "relative" }}>
        <Typography
          gutterBottom
          color="primary"
          style={{
            marginLeft: 7,
            fontSize: `${labelSize}px`,
          }}
        >
          {label} {obligatoire && <span style={{ color: "red" }}>*</span>}
        </Typography>
      </div>
      <TextField
        fullWidth
        placeholder={placeholder}
        onChange={(v) => onChange(v.target.value)}
        multiline={bigField ? true : false}
        rows={3}
        disabled={disabled || !!icon}
        type={isPassword ? (showPassword ? "text" : "password") : "text"}
        {...restProps}
        error={Boolean(error)}
        InputProps={{
          sx: {
            color: "primary",
            height: bigField ? `80px` : `${height}px`,
            backgroundColor: "#F6F6F6",
            ...borderStyles,
          },
          endAdornment: (
            <>
              {isPassword && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={togglePasswordVisibility}
                    edge="end"
                    aria-label="toggle password visibility"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )}
              {icon && (
                <>
                  {valeur && (
                    <InputAdornment position="end">
                      <IconButton onClick={onClearClick} edge="end">
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  )}
                  <InputAdornment position="end">
                    <IconButton onClick={onIconClick} edge="end">
                      {icon}
                    </IconButton>
                  </InputAdornment>
                </>
              )}
              {unite && <InputAdornment position="end">{unite}</InputAdornment>}
            </>
          ),
        }}
        InputLabelProps={{
          sx: { color: "primary", marginTop: "4px" },
        }}
        FormHelperTextProps={{ sx: { color: "primary" } }}
        sx={{
          input: { color: "primary" },
          ...borderStyles,
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#000000",
          },
        }}
      />
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default TextFieldCustomized;
